<template>
    <div>
        <NavBar></NavBar>
        <h3 class="mt-2">Linea de Tubos</h3>
        <h7
      >Seleccione el grupo de formas que corresponda para su tubo.</h7
    >
    <ul>
      <li><router-link to="/TubeQuote"> Grupo 1 - Formas Tipo Estructural</router-link></li>
      <li>Grupo 2 - Formas Tipo Mueble</li>
      <li>Grupo 3 - Formas Tipo Cerramiento</li>
    </ul>
    </div>
</template>
<script>
import NavBar from "@/components/GeneralComponents/NavBarComponent.vue";
export default {
  data() {
    return {

    };
  },
  methods:{

  },
  components:{
    NavBar,
  },
};

</script>
<style scoped>
</style>
